import { render, staticRenderFns } from "./BaseTradeInVoucherSummary.vue?vue&type=template&id=3cc7c5b2&scoped=true"
import script from "./BaseTradeInVoucherSummary.vue?vue&type=script&lang=js"
export * from "./BaseTradeInVoucherSummary.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInVoucherSummary.vue?vue&type=style&index=0&id=3cc7c5b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7c5b2",
  null
  
)

export default component.exports